import { LoadExtractsUsecase, LoadExtractsUsecaseImpl } from 'domain/usecases/extract/load-extracts-usecase';
import { makeExtractsHttpRepository } from '../repositories/http/extrac-http-repository-factory';

export const makeLoadExtractsUsecase = (): LoadExtractsUsecase => {
  return new LoadExtractsUsecaseImpl(makeExtractsHttpRepository());
};
